export const BUSINESS = {
  name: "Najah Kreativitas Utama",
  brand: "EventKu",
  email: "najahkreativitasutama@gmail.com",
  phone: "082228222120",
  phoneIntl: "6282228222120",
  address:
    "Jl. Sumur Bor Jl. Ciharashas No.2811, Cilame, Kec. Ngamprah, Kabupaten Bandung Barat, Jawa Barat 40552",
  hours: "09.00 – 17.00 WIB",
};
